import api from "../api/axiosInstance";

const promoService = {
  getAll: () => api.get("/promos"),
  getOne: (id) => api.get(`/promos/${id}`),
  create: (data) => api.post("/promos", data),
  update: (id, data) => api.patch(`/promos/${id}`, data),
  delete: (id) => api.delete(`/promos/${id}`),
  // Promo discounts already redeemed (at shipment-creation time) against
  // any of these shipments that haven't been billed on an invoice yet —
  // powers the Generate Invoice review panel.
  getForShipments: (shipmentIds) => api.post("/promos/for-shipments", { shipmentIds }),
  // Live "does this code work" PREVIEW for the shipment creation form —
  // customer-accessible, never consumes a redemption either way. Actually
  // redeeming happens server-side when the shipment is created.
  validateCode: (code) => api.post("/promos/validate-code", { code }),
  // Customer's own "My Promos" page — available codes + redemption history.
  getMine: () => api.get("/promos/mine"),
};

export default promoService;
